exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host{left:50%;top:50%;position:fixed;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);width:80rem;height:45rem}@media only screen and (max-width:568px){:host(.is-mobile){width:52.8rem;height:29.7rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./home/en-US/js/wia-video-popup/wia-video-popup.css
// module id = VtUH
// module chunks = 0